import { Description } from "@mui/icons-material";
import axios from "axios";
import { API_BASE_CMS, API_BASE_IMG_URl } from "helper/environment";
// ✅ Configure includes for images + videos
const includes = [
  "field_offsite_image",
  "field_offsite_image.field_media_image",
  "field_offsite_image.field_media_svg_image",
  "field_onsite_offsite_paragraph",
  "field_onsite_offsite_paragraph.field_ci_image",
  "field_onsite_offsite_paragraph.field_ci_image.field_media_image",
  "field_onsite_offsite_paragraph.field_ci_image.field_media_svg_image",
  "field_offsite_section_data"
];
export const getoffsite = async (uid: string): Promise<any> => {
  const url = `${API_BASE_CMS}/jsonapi/node/commercial_industrial_offsite/${uid}?include=${includes.join(",")}`;

  const response = await axios.get(url);

  const node = response.data.data; // single object
  const included = response.data.included || [];

  const getImageFromMedia = (mediaId?: string) => {
    if (!mediaId) return { url: null, alt: null };

    const media = included.find(
      (inc: any) =>
        (inc.type === "media--image" || inc.type === "media--svg_image") &&
        inc.id === mediaId
    );

    if (!media) return { url: null, alt: null };

    const imageField =
      media.relationships?.field_media_image?.data ||
      media.relationships?.field_media_svg_image?.data;

    if (!imageField?.id) return { url: null, alt: null };

    const file = included.find(
      (inc: any) => inc.type === "file--file" && inc.id === imageField.id
    );

    const fileUrl = file?.attributes?.uri?.url
      ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
      : null;

    const altText = imageField?.meta?.alt || media?.attributes?.name || "";

    return {
      url: fileUrl,
      alt: altText,
    };
  };
  const findIncluded = (type: string, id: string) =>
    included.find((item: any) => item.type === type && item.id === id);

  const Image = node.relationships?.field_offsite_image?.data?.id ?? "";
  const slides = node.relationships?.field_onsite_offsite_paragraph?.data
    ?.map((ref: any) => {
      const slide = findIncluded(ref.type, ref.id);
      if (!slide) return null;

      return {
        id: slide.attributes?.drupal_internal__id || 0,
        title: slide.attributes?.field_title_ci?.value ?? "",
        description: slide.attributes?.field_descriptions?.value ??  "",
        images: getImageFromMedia(slide.relationships?.field_ci_image?.data?.id ?? "")
      };
    })
    .filter(Boolean) || [];
    const items = node.relationships?.field_offsite_section_data?.data
    ?.map((ref: any) => {
      const item = findIncluded(ref.type, ref.id);
      if (!item) return null;

      return {
        id: item.attributes?.drupal_internal__id || 0,
        title: item.attributes?.field_offsite_title ?? "",
        specialChar: item.attributes?.field_offsite_special_character ??  "",
        unit: item.attributes?.field_offsite_unit ??  "",
        value: item.attributes?.field_offsite_value ??  ""
      };
    })
    .filter(Boolean) || [];
  return {
    id: node.id,
    title: node.attributes?.field_offsite_tite ?? "",
    subtitle: node.attributes?.field_offsite_sub_title ?? "",
    status: node.attributes?.status,
    images: getImageFromMedia(Image),
    buttonLink : node.attributes?.field_buttonlink ?? "",
    description: node.attributes?.field_offsite_description?.value || "",
    shorttitle: node.attributes?.field_short_title ?? "",
    shortsubtitle: node.attributes?.field_short_sub_title ?? "",
    shortdescription: node.attributes?.field_short_description?.value || "",
    
    slides,
    items

  };
};

const includess = [
  "field_success_stories",
  "field_success_stories.field_ci_image",
  "field_success_stories.field_ci_image.field_media_image",
  "field_success_stories.field_ci_image.field_media_svg_image",
  "field_success_stories_video",
   "field_success_stories_video.field_stories_video",
  // Video media fields
  "field_success_stories_video.field_stories_video.field_media_video_file",   // MP4 file
  // "field_success_stories_video.field_stories_video.field_media_oembed_video" // Remote URL (YouTube/Vimeo)

];
export const getoffsites = async (uid: string): Promise<any> => {
  const url = `${API_BASE_CMS}/jsonapi/node/ci_onsite_offsite_stories/${uid}?include=${includess.join(",")}`;

  const response = await axios.get(url);

  const node = response.data.data; // single object
  const included = response.data.included || [];

  const getImageFromMedias = (mediaId?: string) => {
    if (!mediaId) return { url: null, alt: null };

    const media = included.find(
      (inc: any) =>
        (inc.type === "media--image" || inc.type === "media--svg_image") &&
        inc.id === mediaId
    );

    if (!media) return { url: null, alt: null };

    const imageField =
      media.relationships?.field_media_image?.data ||
      media.relationships?.field_media_svg_image?.data;

    if (!imageField?.id) return { url: null, alt: null };

    const file = included.find(
      (inc: any) => inc.type === "file--file" && inc.id === imageField.id
    );

    const fileUrl = file?.attributes?.uri?.url
      ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
      : null;

    const altText = imageField?.meta?.alt || media?.attributes?.name || "";

    return {
      url: fileUrl,
      alt: altText,
    };
  };
  const findIncluded = (type: string, id: string) =>
    included.find((item: any) => item.type === type && item.id === id);

  const getMediaData = (mediaRel: any) => {
    if (!mediaRel?.data) return null;
  
    const mediaRef = Array.isArray(mediaRel.data) ? mediaRel.data[0] : mediaRel.data;
    if (!mediaRef?.type || !mediaRef?.id) return null;
  
    const media = findIncluded(mediaRef.type, mediaRef.id);
    if (!media) return null;
  
    const imageRel = media.relationships?.field_media_image?.data;
    const videoRel = media.relationships?.field_media_video_file?.data;
    const videoUrl= media.attributes?.field_media_oembed_video;

 if (videoUrl) {
    return {
      url: videoUrl,
      mime: "video/youtube",
      type: "video-remote",
      alt: media.attributes?.name || "",
      title: media.attributes?.name || "",
      videoId: "",
    };
  }
    const fileRel = videoUrl || videoRel;
    if (!fileRel) return null;
  
    const fileRef = Array.isArray(fileRel) ? fileRel[0] : fileRel;
    if (!fileRef?.id) return null;
  
    const file = findIncluded(fileRef.type, fileRef.id);
    if (!file) return null;
  
    const url = file.attributes?.uri?.url
      ? `${API_BASE_IMG_URl}${file.attributes.uri.url}`
      : null;
  
    const mime = file.attributes?.filemime || "";
    const type: "image" | "video" = mime.startsWith("video/") ? "video" : "image";
  
    // ✅ Image ALT
    const alt =
      imageRel?.meta?.alt ||
      media.attributes?.name ||
      "";
  
    // ✅ Video title / name
    const title =
      type === "video"
        ? media.attributes?.name || file.attributes?.filename || ""
        : "";
  
    return { url,mime, type, alt, title };
  };
  const slides = node.relationships?.field_success_stories_video?.data
    ?.map((ref: any) => {
      const slide = findIncluded(ref.type, ref.id);
      if (!slide) return null;

      return {
        id: slide.attributes?.drupal_internal__id || 0,
        description: slide.attributes?.field_descriptions?.value ??  "",
        images: getMediaData(slide.relationships?.field_stories_video ?? "")
      };
    })
    .filter(Boolean) || [];

    const items = node.relationships?.field_success_stories?.data
    ?.map((ref: any) => {
      const item = findIncluded(ref.type, ref.id);
      if (!item) return null;

      return {
        id: item.attributes?.drupal_internal__id || 0,
          title: item.attributes?.field_title_ci?.value ?? "",
        description: item.attributes?.field_descriptions?.value ??  "",

        images: getImageFromMedias(item.relationships?.field_ci_image?.data?.id ?? "")
      };
    })
    .filter(Boolean) || [];
  return {
    id: node.id,
    title: node.attributes?.title ?? "",
    description: node.attributes?.field_content_data ?? "",
    status: node.attributes?.status,
    slides,
    items

  };
};